export const DEEPL_BATCH_SIZE = 50;
export const AWS_BATCH_SIZE = 50;
export const GOOGLE_TRANSLATE_BATCH_SIZE = 128
export const OPENAI_BATCH_SIZE = 128
